import React, { useMemo, useState, useEffect } from 'react';
import { Avatar, Typography } from 'antd';
import { useTheme } from '../../contexts/ThemeContext';
import { FileUploadInput } from '../ui';

const { Text } = Typography;

const ProjectLogoUpload = ({ 
  project, 
  loading, 
  onUpload,
  isNewProject = false
}) => {
  const { theme } = useTheme();
  const [, setForceUpdate] = useState(0);
  const [localLogoUrl, setLocalLogoUrl] = useState(project?.logoUrl);

  // Atualizar logoUrl local quando o projeto ou a URL mudarem.
  useEffect(() => {
    setLocalLogoUrl((currentLogoUrl) => (
      currentLogoUrl === project?.logoUrl ? currentLogoUrl : project?.logoUrl
    ));
  }, [project?.id, project?.logoUrl]);

  // Usar useMemo para garantir que projectAsUser seja atualizado quando project.files mudar
  // DEVE estar antes de qualquer early return para seguir as regras dos hooks
  const projectAsUser = useMemo(() => {
    return {
      id: project?.id,
      userName: project?.name || 'Projeto',
      files: localLogoUrl // Usar o estado local em vez do project.logoUrl
    };
  }, [project?.id, project?.name, localLogoUrl]);

  if (isNewProject) {
    return (
      <div style={{
        padding: 24,
        border: '2px dashed #d9d9d9',
        borderRadius: 8,
        textAlign: 'center',
        backgroundColor: '#fafafa'
      }}>
        <Avatar 
          size={64} 
          style={{ 
            backgroundColor: theme.primary,
            marginBottom: 12
          }}
        >
          {project?.icon || project?.name?.charAt(0) || 'P'}
        </Avatar>
        <div style={{ marginBottom: 12 }}>
          <Text style={{ fontSize: 12, color: '#8c8c8c' }}>
            Salve o projeto primeiro para fazer upload do logo
          </Text>
        </div>
      </div>
    );
  }

  const handleProjectUpload = async (uploadedFiles) => {
    const uploadedFile = Array.isArray(uploadedFiles) ? uploadedFiles[0] : uploadedFiles;
    if (!uploadedFile) return;

    if (typeof uploadedFile === 'string') {
      setLocalLogoUrl((currentLogoUrl) => (
        currentLogoUrl === uploadedFile ? currentLogoUrl : uploadedFile
      ));
    }

    if (onUpload) {
      try {
        // Chamar o handler do componente pai
        await onUpload(uploadedFiles);
        
        // O componente pai deve atualizar o project.logoUrl
        // Mas vamos forçar um re-render aqui também
        setForceUpdate(prev => prev + 1);
      } catch (error) {
        console.error('❌ Erro no handleProjectUpload:', error);
      }
    }
  };

  const handleProjectImageChange = (projectId, imageUrl, fileId) => {
    const nextLogoUrl = fileId || null;

    setLocalLogoUrl((currentLogoUrl) => (
      currentLogoUrl === nextLogoUrl ? currentLogoUrl : nextLogoUrl
    ));

    // Atualizar o projeto localmente (incluindo remoção quando fileId é null)
    if (project) {
      project.logoUrl = nextLogoUrl;
    }
    
    // Forçar re-render
    setForceUpdate(prev => prev + 1);
  };

  return (
    <FileUploadInput
      user={projectAsUser}
      baseUrl="project"
      variant="avatar"
      inputType="images"
      title="Alterar logo do projeto"
      description="JPG, PNG ou GIF até 5MB"
      primaryColor="#722ed1"
      hideUploadWhenHasFiles={false}
      onFileUpload={handleProjectUpload}
      onImageChange={handleProjectImageChange}
      style={{ maxWidth: '300px', margin: '0 auto' }}
    />
  );
};

export default ProjectLogoUpload; 